/* eslint-disable no-restricted-syntax */
export const asyncNoop = async () => {};

const noop = (..._props: unknown[]) => {};

export default noop;
